// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3ZvXE","content":"LayoutSettings_content__1F2MH"};